import { Search } from "lucide-react";

import { Input } from "~/components/ui/input";

interface ClientSearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const ClientSearchBar = ({
  searchQuery,
  setSearchQuery,
}: ClientSearchBarProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Buscar clientes..."
        className="h-9 w-full pl-8 sm:w-[250px]"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>
  );
};

export default ClientSearchBar;
